import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { CSSProperties, useMemo } from "react";
import clsx from "clsx";

type Props = {
  item: InventoryItem;
};

export default function InventoryGridItemPreview({ item }: Props) {
  const width = useMemo(() => `calc(4.375rem * ${item.size.width} - 1px)`, [item.size.width]);
  const height = useMemo(() => `calc(4.375rem * ${item.size.height} - 1px)`, [item.size.height]);

  return (
    <div
      style={
        {
          width,
          height,
          "--width": width,
          "--height": height,
        } as CSSProperties
      }
    >
      <div
        className={clsx("w-full h-full flex items-center justify-center opacity-70", {
          "-rotate-90 ": item.isRotated,
        })}
        style={{
          ...(item.isRotated
            ? { width: "calc(0.8 * var(--height))", height: "calc(0.8 * var(--width))" }
            : { width: "calc(0.8 * var(--width))", height: "calc(0.8 * var(--height))" }),
          backgroundSize: "90% 90%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage: `url(https://cdn.region.game/images/inventory/items/${item.itemId}.webp)`,
        }}
      />
    </div>
  );
}
